import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import type { ResourceIdDto } from '@/api/generated';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';

type Req = {
  noteId: number;
  resource: ResourceIdDto;
};

type Response = void;

type Return = {
  deleteNote: (req: Req) => Promise<Response>;
  isDeletingNote: boolean;
};

export const useDeleteResourceNote = (): Return => {
  const { resourceNoteApi } = useProcessApiClient();

  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      await resourceNoteApi.removeNote(req.resource.resourceId, req.resource.type, req.noteId);
    },
  });

  return {
    deleteNote: mutateAsync,
    isDeletingNote: isPending,
  };
};
